import {
  POST_PREPARING_FOR_ARCHIVE,
  POST_PREPARING_FOR_ARCHIVE_ERROR,
  POST_CREATE_ARCHIVE,
  POST_CREATE_ARCHIVE_ERROR,
  MANUALLY_TRIGGER_MESSAGE,
  DELETE_ARCHIVED_ITEM,
  GET_ARCHIVE,
  GET_CURRENT_YEAR_ARCHIVE,
  GET_ARCHIVE_NUMBER,
  GET_CURRENT_YEAR_ARCHIVE_NUMBER,
  GET_ARCHIVES_FOR_DESTROYING,
  UPDATE_ARCHIVE,
  UPDATE_ARCHIVE_ERROR,
  GET_ARHIVE_FOR_WORD,
  GET_ARHIVE_FOR_WORD_ERROR,
  GET_CERTAIN_ARCHIVE,
  GET_CERTAIN_ARCHIVE_ERROR,
  UPDATE_CERTAIN_ARCHIVE,
  UPDATE_CERTAIN_ARCHIVE_ERROR,
} from "../types";

import {
  preparingForArchiveProps,
  createArchiveProps,
} from "../../types/actions/archive";

import * as api from "../../api/axiosBase";

// prepare for archive
export const preparingForArchive =
  (formData: preparingForArchiveProps, history) => async (dispatch) => {
    try {
      const { data } = await api.preparingForArchive({
        papersArhive: formData,
      });
      dispatch({
        type: POST_PREPARING_FOR_ARCHIVE,
        payload: data.data.arhiveTemplate,
      });
      history.push("/create-archive");
    } catch (error) {
      dispatch({
        type: POST_PREPARING_FOR_ARCHIVE_ERROR,
        payload: error.response.data.message,
      });
    }
  };

export const deleteArchivedItem = (data: any) => (dispatch) => {
  dispatch({ type: DELETE_ARCHIVED_ITEM, payload: data });
};

// archive document
export const createArchive = (formData: any, date: any) => async (dispatch) => {
  console.log(formData);
  try {
    const { data } = await api.createArchive(formData);
    dispatch({
      type: POST_CREATE_ARCHIVE,
      payload: data.data,
    });
    dispatch(deleteArchivedItem(date));
    window.location.reload();
  } catch (error) {
    dispatch({
      type: POST_CREATE_ARCHIVE_ERROR,
      payload: error.response.data.message,
    });
  }
};

// add archive manually
export const addArchiveManually = (formData: any) => async (dispatch) => {
  try {
    const { data } = await api.createArchive(formData);
    dispatch({
      type: POST_CREATE_ARCHIVE,
      payload: data.data,
    });
    window.location.reload();
  } catch (error) {
    dispatch({
      type: POST_CREATE_ARCHIVE_ERROR,
      payload: error.response.data.message,
    });
  }
};

// manually trigger message
/*export const manuallyTrigerSuccess = () => async (dispatch) => {
  try {
    dispatch({
      type: MANUALLY_TRIGGER_MESSAGE
    });
  } catch (error) {
    console.log("error: ", error);
  }
};*/

// all years archive
export const getArchiveOfCurrentUser =
  (page: any, limit: any, query: string) => async (dispatch) => {
    try {
      const { data } = await api.getArchiveOfCurrentUser(page, limit, query);
      dispatch({
        type: GET_ARCHIVE,
        payload: data.data.data,
      });
    } catch (error) {}
  };

export const getArchivesForDestroying = () => async (dispatch) => {
  try {
    const { data } = await api.getArchivesForDestroying();
    dispatch({
      type: GET_ARCHIVES_FOR_DESTROYING,
      payload: data.data.data,
    });
  } catch (error) {}
};

export const allArchiveNumber = (query: string) => async (dispatch) => {
  try {
    const { data } = await api.allArchiveNumber(query);
    dispatch({
      type: GET_ARCHIVE_NUMBER,
      payload: data.data.data,
    });
  } catch (error) {}
};

// current year archive
export const getArchiveOfCurrentUserForCurrentYear =
  (page: number, limit: number, query: string) => async (dispatch) => {
    try {
      const { data } = await api.getArchiveOfCurrentUserForCurrentYear(
        page,
        limit,
        query
      );
      dispatch({
        type: GET_CURRENT_YEAR_ARCHIVE,
        payload: data.data.data,
      });
    } catch (error) {}
  };

// current year archive
export const getArchiveForWord = () => async (dispatch) => {
  try {
    const { data } = await api.getArchiveForWord();
    dispatch({
      type: GET_ARHIVE_FOR_WORD,
      payload: data.data.data,
    });
  } catch (error) {
    dispatch({
      type: GET_ARHIVE_FOR_WORD_ERROR,
      payload: error.response.data,
    });
  }
};

export const currentYearArchiveNumber = (query: string) => async (dispatch) => {
  try {
    const { data } = await api.currentYearArchiveNumber(query);
    dispatch({
      type: GET_CURRENT_YEAR_ARCHIVE_NUMBER,
      payload: data.data.data,
    });
  } catch (error) {}
};

export const manuallyTrigerMessage = () => (dispatch) => {
  dispatch({ type: MANUALLY_TRIGGER_MESSAGE });
};

// update specific archive, using params(id) and query
export const updateArchive =
  (formData: any, id: string) => async (dispatch) => {
    try {
      const { data } = await api.updateArchive(id, formData);
      dispatch({ type: UPDATE_ARCHIVE, payload: data });
      dispatch(getArchivesForDestroying());
      window.location.reload();
      //history.push("/categories");
    } catch (error) {
      dispatch({
        type: UPDATE_ARCHIVE_ERROR,
        payload: error.response.data,
      });
    }
  };

// get certain Paper
export const getCertainArchive = (id: string, history) => async (dispatch) => {
  try {
    const { data } = await api.getCertainArchive(id);
    dispatch({
      type: GET_CERTAIN_ARCHIVE,
      payload: data.data.data,
    });
    history.push("/edit-archive");
  } catch (error) {
    dispatch({
      type: GET_CERTAIN_ARCHIVE_ERROR,
      payload: error.response.data.message,
    });
  }
};

// update certain user
export const updateCertainArchive =
  (formData: any, id, history) => async (dispatch) => {
    try {
      const { data } = await api.updateCertainArchive(formData, id);
      dispatch({ type: UPDATE_CERTAIN_ARCHIVE, payload: data });
      dispatch(getCertainArchive(id, history));
    } catch (error) {
      dispatch({
        type: UPDATE_CERTAIN_ARCHIVE_ERROR,
        payload: error.response.data,
      });
    }
  };
